import clsx from "clsx"
import React from "react"

interface PillProps {
  className?: string
  children: any
}

const Pills: React.FC<PillProps> = ({ children, className }) => (
  <div className={clsx(className, "caption2 py-1 px-3 rounded-full")}>
    {children}
  </div>
)

export default Pills
